"use strict";

exports.__esModule = true;
exports.DeviceList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactWindow = require("react-window");
var _core = require("@blueprintjs/core");
var _DeviceTag = require("../DeviceTag");
var _Core = require("../../Core");
var _System = require("../../../System");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var TagList = _styledComponents["default"].span.withConfig({
  displayName: "DeviceList__TagList",
  componentId: "sc-13hd09u-0"
})([".", "{margin-right:0.5rem;}"], _core.Classes.TAG);

/**
 * Renders Device List View
 */
var DeviceList = exports.DeviceList = /*#__PURE__*/function (_Component) {
  function DeviceList() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DeviceList, _Component);
  var _proto = DeviceList.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      items = _this$props.items,
      screenName = _this$props.screenName,
      height = _this$props.height,
      width = _this$props.width;
    var itemSize = 70;
    return /*#__PURE__*/_react["default"].createElement(_Core.ListView, null, /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
      height: height,
      width: width,
      itemCount: items.length,
      itemSize: itemSize
    }, function (_ref) {
      var index = _ref.index,
        style = _ref.style;
      var device = items[index];
      return /*#__PURE__*/_react["default"].createElement(_Core.ListItemView, {
        key: device.uuid,
        height: itemSize,
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_Core.ListItemViewLink, {
        to: (0, _System.getScreenURL)(screenName, {
          id: device.uuid
        }),
        disabled: !device.enabled
      }, /*#__PURE__*/_react["default"].createElement(_Core.ListItemHeading, {
        level: 4,
        disabled: !device.enabled
      }, device.name), /*#__PURE__*/_react["default"].createElement(TagList, {
        key: device.uuid
      }, device.tags.map(function (tag) {
        return /*#__PURE__*/_react["default"].createElement(_DeviceTag.DeviceTag, {
          minimal: true,
          key: tag,
          value: tag
        });
      }))));
    }));
  };
  return DeviceList;
}(_react.Component);
DeviceList.defaultProps = {
  items: [],
  screenName: "UpdateDevice"
};